export default __webpack_public_path__ + "static/mykhailo-pasternak-cdb9a8bf896a6322a00a97dab555fc7f.png";